import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import {JSONToHTMLTable} from '../../components'
import {connect, useDispatch} from 'react-redux'
import EmailForm from './EmailForm'
import OrganizationForm from '../Organizations/OrganizationForm'
import {showErrorToast, showSuccessToast} from '../../state/toasts'
import {GSXService} from '../../services'

export const GSXLogsDataGrid = ({
                                    results,
                                    page_size,
                                    current,
                                    count,
                                    onTableChange,
                                    onFilter,
                                }) => {
    const dispatch = useDispatch()

    const actionFormatter = (cell, row) => {
        const FormOrganization = connect((state) => ({
            initialValues: row,
        }))(OrganizationForm)
        return (
            <div onClick={(e) => e.stopPropagation()}>
                <ReactBootstrap.Dropdown>
                    <ReactBootstrap.Dropdown.Toggle
                        variant="dark"
                        size="sm"
                    ></ReactBootstrap.Dropdown.Toggle>
                    <ReactBootstrap.Dropdown.Menu>
                        <components.Slider
                            title={<span>{components.ICONS.COMMENTS} View Log </span>}
                            header="API Call Log"
                            variant="light"
                        >
                            <JSONToHTMLTable
                                data={row.log}
                                tableClassName="table table-sm table-striped table-bordered"
                            />
                        </components.Slider>
                        <components.Slider
                            buttonType="dropdown"
                            title={<span>{components.ICONS.COMMENTS} Send Log </span>}
                            header={
                                <span className="pr-3">
                  {components.ICONS.COMMENTS} Send log To Email
                  <span className="pl-1"> {row.code}</span>
                </span>
                            }
                        >
                            <EmailForm
                                id={row.id}
                                onSubmit={(values) => {
                                    values.log_id = row.id
                                    new GSXService()
                                        .send_log_via_email(values)
                                        .then((response) => {
                                            dispatch(showSuccessToast('Log has been sent to email.'))
                                        })
                                        .catch((errors) => {
                                            dispatch(
                                                showErrorToast(
                                                    'Could Not send Log to email..',
                                                    JSON.stringify(errors)
                                                )
                                            )
                                        })
                                }}
                            />
                        </components.Slider>
                    </ReactBootstrap.Dropdown.Menu>
                </ReactBootstrap.Dropdown>
            </div>
        )
    }

    const columns = [
        {
            dataField: 'api',
            text: 'api',
            type: 'string',
            formatter: components.CellTextFormatter,
            searchFieldType: 'text',
        },
        {
            dataField: 'method',
            text: 'method',
            type: 'string',
            formatter: components.CellTextFormatter,
            searchFieldType: 'text',
        },
        {
            dataField: 'version',
            text: 'Version',
            type: 'string',
            formatter: components.CellTextFormatter,
            searchFieldType: 'text',
        },
        {
            dataField: 'gsx_user_name',
            text: 'GSX user name',
            type: 'string',
            formatter: components.CellTextFormatter,
            searchFieldType: 'text',
        },
        {
            dataField: 'device_identifier',
            text: 'Device identifier',
            hidden: true,
            type: 'string',
            formatter: components.CellTextFormatter,
            searchFieldType: 'text',
        },
        {
            dataField: 'gsx_ship_to',
            text: 'Ship To',
            type: 'string',
            formatter: components.CellTextFormatter,
            searchFieldType: 'text',
        },
        {
            dataField: 'created_at',
            text: 'Created On',
            type: 'string',
            formatter: components.CellDateFormatter,
            searchFieldType: 'date',
        },
        {
            dataField: 'log',
            formatter: actionFormatter,
        },
    ]
    return (
        <ReactBootstrap.Card>
            <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
                <ReactBootstrap.Row>
                    <ReactBootstrap.Col xs={6}>GSX Call Logs</ReactBootstrap.Col>
                    <ReactBootstrap.Col className="text-end" xs={6}>
                        <components.Slider
                            size="sm"
                            title={components.ICONS.SEARCH}
                            sliderWidth={"20vw"}
                            header={
                                <span className="pr-3">
                  {components.ICONS.SEARCH}
                                    <span className="pl-1"> GSX Call Logs</span>
                </span>
                            }
                        >
                            <components.GenericSearchForm
                                onFilter={onFilter}
                                columns={columns}
                            />
                        </components.Slider>
                    </ReactBootstrap.Col>
                </ReactBootstrap.Row>
            </ReactBootstrap.Card.Header>
            <ReactBootstrap.Card.Body>
                <components.DataGrid
                    data={results || []}
                    sizePerPage={page_size || 10}
                    page={current || 1}
                    columns={columns}
                    count={count || 0}
                    onTableChange={onTableChange}
                />
            </ReactBootstrap.Card.Body>
        </ReactBootstrap.Card>
    )
}
